module.exports = "<div class=\"job-box\">\n   <h3><i class=\"fa fa-briefcase\" aria-hidden=\"true\"></i>JOB NOTIFICATIONS<span><i class=\"fa fa-bell\" aria-hidden=\"true\"></i></span></h3>\n     <p *ngIf=\"notification?.length > 0\">{{notification[0].title}}</p>\n     <p *ngIf=\"notification?.length == 0\">There is no Notification</p>\n   <a class=\"job-box-viewmore\" *ngIf=\"notification?.length > 0\">» View more</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/uprofile/unotification/unotification.component.html
// module id = ../../../../../src/app/home/uprofile/unotification/unotification.component.html
// module chunks = common